import { useState } from 'react';
import { useCreateEvaluator } from '@/hooks/v2/evaluator';
import { useGetListEvaluator } from '@/hooks/v2/evaluator';
import { useApplicationContext } from '@/context/v1/Application/context';

export function useEvaluator() {
	const [name, setName] = useState<string>('');

	const { organization, company } = useApplicationContext();
	const { mutate: createEvaluator } = useCreateEvaluator();

	const { isLoading, data: evaluators = [] } = useGetListEvaluator({
		organization_id: organization.id!,
		company_id: company.id!
	});

	function handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
		setName(event.target.value);
	}

	function addItem(e: React.MouseEvent<HTMLAnchorElement>): void {
		e.preventDefault();

		if (!name.trim()) {
			return;
		}

		createEvaluator({
			name: name.trim(),
			company_id: company.id!,
			organization_id: organization.id!
		});

		setName('');
	}

	function handleSearch(value: string): void {
		if (value.length > 2) {
		}
	}

	const data = evaluators?.map((evaluator) => ({
		label: evaluator.name,
		value: evaluator.id
	}));

	return { isLoading, data, addItem, handleSearch, handleInputChange };
}
